import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { mockPRs } from '../data/mockData';
import { RFQPanel } from '../components/procurement/RFQPanel';
import { StatusBadge } from '../components/StatusBadge';
export function RFQAction() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const pr = mockPRs.find(p => p.id === id);
  if (!pr) {
    return <div className="flex flex-col items-center justify-center h-full" data-id="element-2277">
        <h2 className="text-xl font-bold text-gray-900" data-id="element-2278">PR not found</h2>
        <button onClick={() => navigate('/rfq')} className="mt-4 text-indigo-600 hover:text-indigo-800" data-id="element-2279">
          Back to RFQ List
        </button>
      </div>;
  }
  return <div className="max-w-6xl mx-auto space-y-6 pb-12" data-id="element-2280">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-2281">
        <div className="flex items-center space-x-4" data-id="element-2282">
          <button onClick={() => navigate('/rfq')} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors" data-id="element-2283">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-2284" />
          </button>
          <div data-id="element-2285">
            <div className="flex items-center space-x-3" data-id="element-2286">
              <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-2287">
                Process RFQ
              </h1>
              <StatusBadge status="Draft" data-id="element-2288" />
            </div>
            <p className="text-sm text-gray-500 mt-1" data-id="element-2289">
              Request for Quotation for {pr.prNo}
            </p>
          </div>
        </div>
      </div>

      {/* PR Context Card */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 flex flex-wrap gap-6" data-id="element-2290">
        <div data-id="element-2291">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2292">
            PR Number
          </p>
          <p className="mt-1 text-sm font-medium text-gray-900" data-id="element-2293">{pr.prNo}</p>
        </div>
        <div data-id="element-2294">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2295">
            Originator
          </p>
          <p className="mt-1 text-sm font-medium text-gray-900" data-id="element-2296">
            {pr.originator}
          </p>
        </div>
        <div data-id="element-2297">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2298">
            Method
          </p>
          <p className="mt-1 text-sm font-medium text-gray-900" data-id="element-2299">
            {pr.procurementMethod}
          </p>
        </div>
        <div data-id="element-2300">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2301">
            Total Amount
          </p>
          <p className="mt-1 text-sm font-medium text-gray-900" data-id="element-2302">
            ${pr.total.toLocaleString()}
          </p>
        </div>
      </div>

      {/* Embedded Panel */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6" data-id="element-2303">
        <RFQPanel data-id="element-2304" />
      </div>
    </div>;
}